import { render, staticRenderFns } from "./CreateSubjectCategoryModal.vue?vue&type=template&id=59acc035&"
import script from "./CreateSubjectCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateSubjectCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports